import { cn } from '@/helpers/classnames';
import { ReactNode } from 'react';

interface ListCounterProps<T> {
  totalItems: T[];
  filteredItems: T[];
  type?: ReactNode;
  className?: string;
}

export const ListCounter = <T,>({
  totalItems,
  filteredItems,
  type,
  className,
}: ListCounterProps<T>) => {
  return (
    <div
      className={cn(
        'my-2 flex w-full gap-1 text-text-700 md:mb-0 md:px-0 md:py-4',
        className,
      )}
    >
      <span className="font-medium">
        {filteredItems.length < totalItems.length
          ? `${filteredItems.length} av ${totalItems.length} `
          : totalItems.length}
      </span>
      <span>{type}</span>
    </div>
  );
};
